import React from 'react';
import type { IFormElement } from '../types';
import styles from './fields.module.css';

export interface HtmlFieldProps {
  element: IFormElement;
  questionNumber?: number;
}

export const HtmlField: React.FC<HtmlFieldProps> = ({
  element,
  questionNumber,
}) => {
  const htmlContent = element.html || '';

  const renderLabel = () => {
    if (!element.title) return null;
    return (
      <label className={styles.label}>
        {questionNumber && (
          <span className={styles.questionNumber}>{questionNumber}. </span>
        )}
        {element.title}
      </label>
    );
  };

  return (
    <div className={styles.formField}>
      {renderLabel()}
      <div
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{
          padding: '1rem',
          backgroundColor: 'var(--df-background-secondary, #f9f9f9)',
          borderRadius: '4px',
          lineHeight: 1.6,
        }}
      />
    </div>
  );
};

export default HtmlField;
